export default "/images/document-text.svg?a196e123d9438aca236ee0dcb3966b87";